import { useEffect, useState } from 'react';

const urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // validate protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
        '(\\#[-a-z\\d_]*)?$',
    'i'
); // validate fragment locator

export function checkUrlIsValid(urlString: string) {
    return Boolean(urlPattern.test(urlString));
}

export async function checkUrlIsCompatibleWithIFrame(uri?: string) {
    try {
        if (!uri || !checkUrlIsValid(uri)) return false;

        const response = await fetch(uri);
        const frameOptions = response.headers?.get('x-frame-options')?.toUpperCase();

        if (frameOptions === 'SAMEORIGIN' || frameOptions === 'DENY') {
            return false;
        }

        return true;
    } catch (error) {
        return false;
    }
}

export function useCheckUrlCompatibility(uri?: string) {
    const [loading, setLoading] = useState(false);
    const [isCompatible, setIsCompatible] = useState(true);

    useEffect(() => {
        setLoading(true);
        checkUrlIsCompatibleWithIFrame(uri)
            .then(isCompatible => {
                setIsCompatible(isCompatible);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [uri]);

    return { isCompatible, loading };
}
